import { render, staticRenderFns } from "./InspectValueDialog.vue?vue&type=template&id=1395485e&scoped=true&"
import script from "./InspectValueDialog.vue?vue&type=script&lang=ts&"
export * from "./InspectValueDialog.vue?vue&type=script&lang=ts&"
import style0 from "./InspectValueDialog.vue?vue&type=style&index=0&id=1395485e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395485e",
  null
  
)

export default component.exports